module.exports = __webpack_public_path__ + "img/frontyard-bb.b0726217.png";